var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomAltLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00002,
    cy: 8.00008,
    r: 0.833333,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 1.83325C8.62869 1.83325 9.33325 2.356 9.90985 3.50903C10.4715 4.6324 10.8337 6.22009 10.8337 8.00024C10.8336 9.78027 10.4715 11.3672 9.90985 12.4905C9.33322 13.6437 8.62874 14.1663 7.99969 14.1663C7.37076 14.1661 6.66703 13.6434 6.09052 12.4905C5.52886 11.3672 5.16673 9.78027 5.16669 8.00024C5.16669 6.22009 5.52883 4.6324 6.09052 3.50903C6.66701 2.35629 7.3708 1.83343 7.99969 1.83325Z",
    stroke: "black",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.99976C14.1667 8.62875 13.6439 9.33331 12.4909 9.90991C11.3675 10.4716 9.77985 10.8337 7.99969 10.8337C6.21967 10.8337 4.63276 10.4716 3.50946 9.90991C2.35625 9.33328 1.83368 8.6288 1.83368 7.99976C1.83386 7.37082 2.35654 6.66709 3.50946 6.09058C4.63276 5.52892 6.21967 5.16679 7.99969 5.16675C9.77985 5.16675 11.3675 5.52889 12.4909 6.09058C13.6436 6.66707 14.1665 7.37087 14.1667 7.99976Z",
    stroke: "black",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomAltLight);
export default __webpack_public_path__ + "static/media/Atom_alt_light.c495d05e91bc081969cc3dc065bbae9c.svg";
export { ForwardRef as ReactComponent };